import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

/** Mirrors the LiveSessionCard layout: 182x102 banner beside a three-line stack. */
export const LiveSessionCardSkeleton: FC = () => (
  <Box
    sx={{
      bgcolor: 'common.white',
      border: '1px solid',
      borderColor: 'grey.200',
      borderRadius: '15px',
      p: 2,
      display: 'flex',
      gap: '15px',
      alignItems: { xs: 'stretch', sm: 'flex-start' },
      flexDirection: { xs: 'column', sm: 'row' },
    }}
  >
    <Skeleton variant="rectangular" height={102} sx={{ width: { xs: '100%', sm: 182 }, borderRadius: '8px' }} />

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '7px', flex: 1, minWidth: 0 }}>
      <Skeleton variant="text" width={120} height={18} />
      <Skeleton variant="text" width="45%" height={22} />
      <Skeleton variant="text" width={140} height={19} />

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5, mt: 0.5 }}>
        <Skeleton variant="text" width={280} height={19} />
        <Skeleton variant="rectangular" width={140} height={32} sx={{ borderRadius: '8px' }} />
      </Box>
    </Box>
  </Box>
);
